// Polyfill for vue-input-facade on IE
// (not included in core-js)
import 'custom-event-polyfill';

// Register class components hooks
import Component from 'vue-class-component';

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteLeave',
	'beforeRouteUpdate'
]);

import './plugins/vue-dot';
import './plugins/form-builder';
import './plugins/webfontloader';
import './plugins/vue-matomo';

import Vue from 'vue';

import App from './App.vue';
import { router } from './router';
import { store } from './store';
import { vuetify } from './plugins/vuetify';
import { i18n } from './i18n';

Vue.config.productionTip = false;
Vue.prototype.$QRP_PUBLIC_URL = '/';
Vue.prototype.$SSPA_ENABLED = false;

// Create main Vue instance
new Vue({
	router,
	store,
	i18n,
	vuetify,
	render: (h) => h(App)
}).$mount('#app'); // Mount it on #app (in public/index.html)
